import { render, staticRenderFns } from "./RecruitDetail.vue?vue&type=template&id=624bdc01&scoped=true"
import script from "./RecruitDetail.vue?vue&type=script&lang=js"
export * from "./RecruitDetail.vue?vue&type=script&lang=js"
import style0 from "./RecruitDetail.vue?vue&type=style&index=0&id=624bdc01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624bdc01",
  null
  
)

export default component.exports